<template>
	 <div >
			<v-row no-gutters>
        <v-col cols="12" sm="6" md="3" lg="2" style="text-align: center" v-if="showImg1" class="desktop">
          <v-img :src="showImg1 ? img1 : ''" contain height="50"></v-img>
        </v-col>
        <v-col cols="12" sm="6" md="9" lg="10" style="text-align: center">
          <!--<div style="float: left; width: 100px" class="animarLeft desktop" >-->
            <!--<v-img :src="showImg1 ? img1 : ''" contain height="50"></v-img>-->
          <!--</div>-->
          <div style="float: right; width: 100px"  class="animarUp desktop">
            <v-img :src="showImg2 ? img2 : ''" contain :height="h" ></v-img>
          </div>
          <div v-html="html_code" style="width: 100%"></div>
          <!--<h1 class="baloo_paaji_bold animarDown"-->
              <!--:style="'font-size: 5rem; font-weight: bold; color: '+cor1+';line-height: 1em;'">{{txt1}}</h1>-->
          <!--<h1 class="baloo_paaji_bold animarUp"-->
              <!--:style="'font-size: 4rem; font-weight: bold; color:  '+cor2+';line-height: 1em;' ">{{txt2}}</h1>-->
          <slot></slot>
        </v-col>
      </v-row>
	 </div>
</template>

<script async>
  /* eslint-disable */
  export default {
    name: 'TxtBanner',
    // props:['img1','img2','txt1','txt2'],
    props:{
      img1: {default: ''},
      img2: {default: ''},
      txt1: {default: ''},
      size1: {default: '4rem'},
      size2: {default: '4rem'},
      txt2: {default: ''},
      tag: {default: ''},
      tag2: {default: ''},
      showImg1: {default: true},
      showImg2: {default: true},
      cor1: {default: '#C9182A'},
      cor2: {default: '#EDA53E'},
    },
    components: {},
    data: () => ({
      html_code: '',
      h: '100',
    }),
    methods: {
      configurar(){
        // console.log('configurar')
        var div = document.createElement('div')
        // var div = document.getElementById('demo')

        if (this.tag !== '' && this.tag !== null && this.tag !== undefined) {
          var elemento1 = document.createElement(this.tag)
          elemento1.className = 'txt_banner baloo_paaji_bold animarDown '

          // elemento1.style=' font-weight: bold; color: '+this.cor1+';line-height: 1em;'
          elemento1.style='font-size: '+this.size1+'; font-weight: bold; color: '+this.cor1+';line-height: 1em;'
          elemento1.innerText = this.txt1
          div.appendChild(elemento1)
        }
        if (this.tag2 !== '' && this.tag2 !== null && this.tag2 !== undefined) {
          var elemento2 = document.createElement(this.tag2)
          elemento2.className = 'txt_banner baloo_paaji_bold animarUp '
          // elemento2.style='font-weight: bold; color: '+this.cor2+';line-height: 1em;'
          elemento2.style='font-size: '+this.size2+'; font-weight: bold; color: '+this.cor2+';line-height: 1em;'
          elemento2.innerText = this.txt2
          div.appendChild(elemento2)
        }
        this.html_code=div.innerHTML;

      }
    },
    created() {
    },
    mounted() {
      this.configurar()
    },
    computed: {},
    watch: {}
  }
</script>

<style scoped>
</style>
